import cloud from "../../../assets/cloud.svg";
import dots from "../../../assets/dots.svg";

export const features = [
  {
    icon: cloud,
    title: "Store data on cloud",
    content: "Create beautiful landing pages with Rareblocks that converts.",
  },
  {
    icon: dots,
    title: "Connect dots smartly",
    content: "Create beautiful landing pages with Rareblocks that converts.",
  },
];
